import { useState, useEffect, useReducer } from "react";
import "./assets/css/tailwind.css";
import "./assets/scss/tailwind.scss";
import { Route, Routes } from "react-router-dom";
import Index from "./pages/index.js";
import Loader from "./component/Loader";
import UserContext from "contexts/UserContext";
import DashboardPage from "pages/dashboard/index.js";
import userReducer, {
	initialState as userInitialState,
} from "reducers/userReducer";
import LoginContainer from "pages/auth/LoginContainer";
import RaiseDemandWork from "pages/RaiseDemandWork";
import PrivateRoute from "component/PrivateRoute";
import { RoleProvider } from "contexts/RoleContext";
import PublicRaiseDemandWork from "pages/PublicRaiseDemandWork";
import UpdatePasswordPage from "pages/auth/UpdatePasswordPage";
import OTPVerificationPage from "pages/auth/OTPVerificationPage";
import ForgotPassword from "pages/auth/ForgotPassword";

const App = () => {
	const [loading, setLoading] = useState(false);
	const [userState, userDispatch] = useReducer(userReducer, userInitialState);
	const userContext = { userState, userDispatch };

	useEffect(() => {
		document.documentElement.setAttribute("dir", "ltr");
		handleRouteChange();
	}, []);

	const handleRouteChange = () => {
		setLoading(false);
	};

	return (
		<UserContext.Provider value={userContext}>
			<RoleProvider>
				{loading && <Loader />}
				<Routes>
					<Route path="/" element={<Index />} />
					<Route path="/index" element={<Index />} />
					<Route path="/auth-login" element={<LoginContainer />} />

					<Route
						path="/raise-demand-work-public"
						element={<PublicRaiseDemandWork />}
					/>
					<Route
						path="/auth-otp-verification"
						element={<OTPVerificationPage />}
					/>

					<Route path="/auth-forgot-password" element={<ForgotPassword />} />
					<Route
						path="/auth-update-password"
						element={<UpdatePasswordPage />}
					/>

					<Route element={<PrivateRoute />}>
						<Route path="/core/*" element={<DashboardPage />} />
						<Route
							path="/auth-reset-password"
							element={<UpdatePasswordPage />}
						/>

						<Route
							path="/core/raise-demand-work"
							element={<RaiseDemandWork />}
						/>
					</Route>
				</Routes>
			</RoleProvider>
		</UserContext.Provider>
	);
};

export default App;
